<template>
  <div id="EditActive2" class="well" style="padding: 0 1em">
    <div>
      <button
        href="#"
        @click.prevent="close()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回活動列表
      </button>
    </div>
    <div class="form-group">
      <table class="table" style="width: 100%; align: left">
        <tbody style="width: 70%; align: left">
          <tr
            class="table-success"
            align="left"
            style="width: 70%; align: left"
          >
            <td>
              <div>
                <span class="red_star">＊</span>活動類型:<br />
                <select
                  v-model="inputData.sn"
                  @change="updateActiveClass(inputData.sn)"
                >
                  <option selected="selected" value="">請選擇活動類型</option>
                  <option
                    v-for="item in inputData7"
                    :key="item.sn"
                    :value="item.sn"
                    :disabled="true"
                  >
                    {{ item.typeName }}
                  </option></select
                ><br />

                <b-form-group
                  v-if="PublicizeEnable"
                  v-slot="{ ariaDescribedby2 }"
                >
                  <b-form-radio-group
                    v-model="inputData.studentGroup"
                    :options="options2"
                    :aria-describedby="ariaDescribedby2"
                    name="radio-inline"
                  ></b-form-radio-group>
                </b-form-group>
                <b-form-group
                  v-if="SeminarEnable"
                  v-slot="{ ariaDescribedby3 }"
                >
                  <b-form-radio-group
                    v-model="inputData.studentGroup"
                    :options="options3"
                    :aria-describedby="ariaDescribedby3"
                    name="radio-inline"
                  ></b-form-radio-group>
                </b-form-group>
              </div>
            </td>
          </tr>
          <tr
            v-if="!ForumEnable"
            class="table-success"
            align="left"
            style="width: 70%; align: left"
          >
            <td>
              <div>
                <div v-if="localInputData3 != null">
                  <span class="red_star">＊</span>地區:<br />
                  <select v-model="inputData.cid" @change="updateCity">
                    <option selected="selected" value="">請選擇地區</option>
                    <option
                      v-for="school in localInputData3"
                      :key="school.cid"
                      :value="school.cid"
                      :disabled="true"
                    >
                      {{ school.city }}
                    </option></select
                  ><br />
                </div>

                <div v-if="localInputData2 != null">
                  <span class="red_star">＊</span>學校名稱:<br />
                  <select v-model="inputData.schoolID" @change="updateSchool">
                    <option selected="selected" value="">請選擇學校名稱</option>
                    <option
                      v-for="school in localInputData2"
                      :key="school.schoolID"
                      :value="school.schoolID"
                      :disabled="true"
                    >
                      {{ school.schoolName }}
                    </option></select
                  ><br />
                </div>

                <div v-if="localInputData5 != null">
                  <span class="red_star">＊</span>高中職窗口:<br />
                  <select
                    v-model="inputData.sid"
                    @change="updateSchoolContact2"
                  >
                    <option selected="selected" value="">
                      請選擇高中職窗口
                    </option>
                    <option
                      v-for="school in localInputData5"
                      :key="school.sid"
                      :value="school.sid"
                      :disabled="true"
                    >
                      {{ school.unitName }}{{ school.contactName }}
                    </option>
                  </select>
                </div>
              </div>
            </td>
          </tr>
          <tr
            v-if="
              localInputData6 != null && !ForumEnable && inputData.sid != null
            "
          >
            <td>
              <label>單位名稱:</label>{{ localInputData6.unitName }}/&nbsp;
              <label>姓名:</label>{{ localInputData6.contactName }}/&nbsp;
              <label>職稱:</label>{{ localInputData6.jobTitle }}/&nbsp;
              <label>聯絡電話/手機電話:</label
              >{{ localInputData6.cellPhone }}/&nbsp; <label>EMail:</label
              >{{ localInputData6.eMail }}&nbsp;
            </td>
          </tr>
          <tr class="table-success">
            <td>
              <div>
                <span class="red_star">＊</span>活動名稱:
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.activeName"
                  :readonly="true"
                />
              </div>
              <div>
                {{ inputData.activeName }}
              </div>
            </td>
          </tr>
          <!-- <tr>
            <td>
              <div>
                <span class="red_star">＊</span>活動開始時間：<br />
                <flat-pickr
                  v-model="inputData.sActiveTime"
                  :config="flatpickrConfig"
                  :disabled="true"
                  ref="flatpickrInstance"
                ></flat-pickr>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>活動結束時間：<br />
                <flat-pickr
                  v-model="inputData.eActiveTime"
                  :config="flatpickrConfig"
                  :disabled="true"
                  ref="flatpickrInstance"
                ></flat-pickr>
              </div>
            </td>
          </tr> -->
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>活動開始時間：<br />
                <div>
                  {{ inputData.sActiveTime }}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>活動結束時間：<br />
                <div>
                  {{ inputData.eActiveTime }}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>招生處人員是否出席或陪同：<br />
                <input
                  type="radio"
                  name="Accompany"
                  value="true"
                  v-model="inputData.accompany"
                  aria-label="Radio button for following text input"
                />有

                <input
                  type="radio"
                  name="Accompany"
                  value="false"
                  v-model="inputData.accompany"
                  aria-label="Radio button for following text input"
                />沒有
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>登記交通車:

                <div
                  class="form-check form-check-inline"
                  v-for="(option, index) in registerCarOptions"
                  :key="index"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="registerCarArray"
                    :value="option.value"
                    :id="'inlineCheckbox' + option.value"
                  />
                  <label
                    :for="'inlineCheckbox' + option.value"
                    class="form-check-label"
                    >{{ option.label }}</label
                  >
                </div>
              </div>
            </td>
          </tr>
          <tr class="table-success" align="left">
            <td>
              司機相關資訊
              <div class="input-group-text">
                <button
                  href="#"
                  @click.prevent="driverChang(true)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  校內司機
                </button>
                <button
                  href="#"
                  @click.prevent="driverChang(false)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  校外司機
                </button>
              </div>
            </td>
          </tr>

          <tr align="left" v-if="DriverEnable">
            <td>
              <div>
                姓名電話:<br />
                <select v-model="inputData.driverName">
                  <option selected="selected" value="">請選擇姓名電話</option>
                  <option
                    v-for="diver in diverOptions1"
                    :key="diver.value"
                    :value="diver.value"
                  >
                    {{ diver.value }}
                  </option></select
                ><br />

                <!-- 聯絡電話:<br />
                <select v-model="inputData.driverPhone" >
                  <option selected="selected" value="">請選擇聯絡電話</option>
                  <option
                    v-for="diver in diverOptions2"
                    :key="diver.value"
                    :value="diver.value"
                  >
                    {{ diver.value }}
                  </option></select
                ><br /> -->

                車牌號碼:<br />
                <select v-model="inputData.licensePlate">
                  <option selected="selected" value="">請選擇車牌號碼</option>
                  <option
                    v-for="diver in diverOptions3"
                    :key="diver.value"
                    :value="diver.value"
                  >
                    {{ diver.value }}
                  </option></select
                ><br />
              </div>
            </td>
          </tr>
          <tr v-if="!mode2 && !DriverEnable">
            <td>
              <div>
                校外司機姓名：<br />
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.driverName"
                  placeholder="校外司機姓名"
                />
              </div>
              <div>
                校外司機聯絡電話：<br />
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.driverPhone"
                  placeholder="校外司機聯絡電話"
                />
              </div>
              <div>
                車牌號碼：<br />
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.licensePlate"
                  placeholder="車牌號碼"
                />
              </div>
            </td>
          </tr>

          <tr align="left" style="width: 70%; align: left">
            <td>
              <div>
                <span class="red_star">＊</span>交通方式:<br />

                <b-form-group>
                  <b-form-checkbox-group
                    v-model="inputData.tidsArray"
                    :options="options4"                    
                    name="inputData.tidsArray"
                  ></b-form-checkbox-group>
                </b-form-group>
              </div>
            </td>
          </tr>
          <tr v-if="!ForumEnable" class="table-success">
            <td>
              <div>
                集合時間(統一出發)：<br />
                <flat-pickr
                  v-model="inputData.schoolGatherTime"
                  :config="flatpickrConfig2"
                  :disabled="true"
                ></flat-pickr>
              </div>
            </td>
          </tr>
          <tr v-if="placeInput != null" align="left">
            <td>
              <div>
                集合地點(統一出發):
                <b-form-group v-slot="{ ariaDescribedby5 }">
                  <b-form-radio-group
                    v-model="inputData.pid"
                    :options="placeInput"
                    :aria-describedby="ariaDescribedby5"
                    name="inputData.pid"
                  ></b-form-radio-group>
                </b-form-group>
                <button @click="clearPlacePID">清除</button>
              </div>
            </td>
          </tr>
          <tr v-if="!ForumEnable" class="table-success">
            <td>
              <div>
                集合時間(自行前往)：<br />
                <flat-pickr
                  v-model="inputData.goBySelfGatherTime"
                  :config="flatpickrConfig2"
                  :disabled="true"
                ></flat-pickr>
              </div>
            </td>
          </tr>
          <tr v-if="!ForumEnable">
            <td>
              <div>
                集合地點(自行前往)：<br />
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.goBySelfGatherPlace"
                  :disabled="true"
                  placeholder="集合地點(自行前往)"
                />
              </div>
            </td>
          </tr>
          <tr v-if="!ForumEnable" class="table-success" align="left">
            <td>
              <span class="red_star">＊</span>上傳該校校園地圖檔案
              <div class="input-group-text">
                <input
                  type="radio"
                  name="campusMap"
                  value="false"
                  checked
                  @click="campusMapChang(0)"
                  v-model="inputData.campusMap"
                  :disabled="true"
                  aria-label="Radio button for following text input"
                />無

                <input
                  type="radio"
                  name="campusMap"
                  value="true"
                  @click="campusMapChang(1)"
                  v-model="inputData.campusMap"
                  aria-label="Radio button for following text input"
                />有
              </div>
            </td>
          </tr>
          <tr
            align="left"
            v-if="inputData.file != undefined && mode && !ForumEnable"
          >
            <td>
              <div>
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="inputData.file"
                  @input="fileChange(0)"
                  placeholder="上傳圖片"
                  accept="image/jpeg, image/png, image/gif,application/pdf"
                ></b-form-file>
              </div>
              <div>
                <span v-if="inputData.file.RowId != undefined">
                  <a
                    :href="
                      './WebApi/Common/GetDocumentFile/' + inputData.file.RowId
                    "
                    target="_blank"
                    :title="inputData.name"
                  >
                    <img
                      src="@/assets/images/disk.png"
                      style="width: 1.5em; height: 1.5em"
                    />
                  </a>
                  {{
                    inputData.file.RowId != undefined ? inputData.file.name : ""
                  }}
                </span>
              </div>
              <div slot="tip" class="el-upload__tip">
                上傳之檔案格式：
                <ul style="list-style-type: disc">
                  <li>副檔名.jpg、.png、.pdf</li>
                  <li>檔案含英文字母共計 60 碼為檔名。</li>
                  <li>
                    檔案尺寸建議870*350像素，解析度建議150*150dpi，位元深度24，大小不得超過
                    4MB。
                  </li>
                </ul>
              </div>
            </td>
          </tr>

          <tr v-if="ClassEnable" class="table-success">
            <td>
              <div>
                <span class="red_star">＊</span>班級數：<br />
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.classNumber"
                  :disabled="true"
                  placeholder="班級數"
                />
              </div>
            </td>
          </tr>
          <tr v-if="ClassEnable || StudentEnable">
            <td>
              <div>
                <span class="red_star">＊</span>學生人數(DM數)：<br />
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.studentNumber"
                  placeholder="學生人數(DM數)"
                />
              </div>
            </td>
          </tr>

          <tr class="table-success" align="left">
            <td>
              <div>
                <span class="red_star">＊</span>本活動小組長/手機：
                <b-form-select
                  text="請選擇本活動小組長"
                  class="select_text"
                  style="width: 20rem"
                  v-model="inputData.eid"
                  @change="updateEnrollContact"
                >
                  <b-form-select-option
                    v-for="item in inputData8"
                    :key="item.eid"
                    :value="item.eid"

                    >{{ item.name }}, {{ item.cellPhone }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>本活動宣導人數：<br />
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.activeNumber"                  
                  placeholder="本活動宣導人數"
                />
              </div>
            </td>
          </tr>
          <tr v-if="ClassEnable" class="table-success" align="left">
            <td>
              <span class="red_star">＊</span>班級
              <div class="input-group-text">
                <input
                  type="radio"
                  :value="false"
                  checked
                  @click="classChang(0)"
                  v-model="inputData.class"
                  :disabled="true"
                  aria-label="Radio button for following text input"
                />無

                <input
                  type="radio"
                  :value="true"
                  @click="classChang(1)"
                  v-model="inputData.class"
                  :disabled="true"
                  aria-label="Radio button for following text input"
                />有
              </div>
            </td>
          </tr>
          <tr align="left" v-if="classMode && ClassEnable">
            <td>
              <div>
                <span class="red_star">＊</span>數量：<br />
                <input
                  type="Number"
                  class="form-control"
                  v-model="inputData.classNumber2"
                  :disabled="true"
                  placeholder="數量"
                  @change="classChang(2)"
                />
              </div>
            </td>
          </tr>

          <tr
            class="table-success"
            align="left"
            v-if="classMode2 && inputData.classNumber2 > 0 && ClassEnable"
          >
            <td>
              <div
                style="display: flex; align-items: center"
                v-for="(index, idx) in inputData.classNumber2"
                :key="'a' + idx"
              >
                <b-form-group v-slot="{ ariaDescribedby6 }">
                  <span class="red_star">＊</span>班級名稱：
                  <input
                    type="text"
                    :disabled="true"
                    v-model="inputData.classNameArray[index - 1]"
                    placeholder="班級名稱"
                  />

                  <b-form-checkbox-group
                    v-model="inputData.depIDStringArray[index - 1]"
                    :aria-describedby="ariaDescribedby6"
                    name="checkbox-group"
                    :id="'cbx' + index"
                    @change="
                      handleCheckboxChange(
                        inputData.depIDStringArray[index - 1],
                        index - 1
                      )
                    "
                  >
                    <b-form-checkbox
                      v-for="(item, itIdx) in options6"
                      :key="'C' + itIdx"
                      :value="item.value"
                      :disabled="
                        (inputData.depIDStringArray[index - 1].includes(
                          '999'
                        ) &&
                          item.value != '999') ||
                        (inputData.depIDStringArray[index - 1].length > 0 &&
                          !inputData.depIDStringArray[index - 1].includes(
                            '999'
                          ) &&
                          item.value == '999')
                      "
                      >{{ item.text }}</b-form-checkbox
                    >
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <!-- (inputData.depIDStringArray[index - 1].includes('999') && item.value !== '999'): 如果 inputData.depIDStringArray[index - 1] 包含 '999'，並且 item.value 不是 '999'，則禁用該 checkbox。這是為了確保在選取 '不指定' 時，只有 '不指定' 的選項可用。

(inputData.depIDStringArray[index - 1].length > 0 && !inputData.depIDStringArray[index - 1].includes('999') && item.value === '999'): 如果 inputData.depIDStringArray[index - 1] 的長度大於 0，並且它不包含 '999'，並且 item.value 是 '999'，則禁用該 checkbox。這是為了確保在取消選取 '不指定' 時，只有 '不指定' 的選項可用。 -->
            </td>
          </tr>
          <tr class="table-success">
            <td>
              <div>
                <span class="red_star">＊</span>經費來源

                <div
                  class="form-check form-check-inline"
                  v-for="(option, index) in budgetOptions"
                  :key="index"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="budgetArray"
                    :value="option.value"
                    :id="'inlineCheckbox' + option.value"
                  />
                  <label
                    :for="'inlineCheckbox' + option.value"
                    class="form-check-label"
                    >{{ option.label }}</label
                  >
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>報名開始時間：<br />
                <flat-pickr
                  v-model="inputData.sdateTime"
                  :config="flatpickrConfig3"
                  :disabled="true"
                ></flat-pickr>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                <span class="red_star">＊</span>報名結束時間：<br />
                <flat-pickr
                  v-model="inputData.edateTime"
                  :config="flatpickrConfig3"
                  :disabled="true"
                ></flat-pickr>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div>
                備註：<br />
                <input
                  type="text"
                  class="form-control"
                  v-model="inputData.remark"
                  :disabled="true"
                  placeholder="備註"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="text-align: center">
      <button
        href="#"
        @click.prevent="EditActive2()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px"
      >
        送出
      </button>
    </div>
  </div>
</template>


<script>
import * as tools from "../tool";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { tw } from "flatpickr/dist/l10n/zh-tw.js";

export default {
  name: "EditActive2",
  //props: ["aid","sn"],
  props: {
    inputData3: {
      type: Array,
      required: true,
    },
    orglocalInputData3: {
      type: Array,
      required: true,
    },
    aid: {
      type: Number,
      required: true,
    },
    sn: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      StudentEnable: false,
      DriverEnable:true,
      mode2: false,
      mode: false,
      classMode: false,
      classMode2: false,
      file: [{ name: "", RowId: "" }],
      sActiveTime: null,
      eActiveTime: null,
      GoBySelfGatherTime: null,
      localInputData3: [], // 使用組件內部的 data 來保存 inputData3 的副本
      orglocalInputData4: null,
      flatpickrConfig: {
        enableTime: true,
        weekNumbers: true,
        dateFormat: "Y-m-d l h:i K",
        altInput: true,
        altFormat: "Y-m-d l h:i K",
        time_24hr: false, // 這應該強制使用 12 小時制
        locale: {
          weekdays: {
            shorthand: ["日", "一", "二", "三", "四", "五", "六"],
            longhand: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
          },
        },
      },
      flatpickrConfig3: {
        enableTime: true,
        weekNumbers: true,
        time_24hr: true, // 這應該強制使用 24 小時制
        dateFormat: "Y-m-d  H:i",
        altInput: true,
        altFormat: "Y-m-d  H:i",
      },

      flatpickrConfig2: {
        enableTime: true,
        noCalendar: true, // 這將禁用日期部分，只顯示時間
        time_24hr: true, // 這應該強制使用 24 小時制
        dateFormat: "H:i",
        altInput: true,
        altFormat: "H:i",
      },
      inputFlag: false,

      PublicizeEnable: false,
      SeminarEnable: false,
      ForumEnable: false,
      ClassEnable: false,
      selected: null,
      budgetArray: [],
      budgetOptions: [
        { value: 1, label: "高教經費" },
        { value: 2, label: "選才計畫" },
        { value: 3, label: "技高經費" },
        { value: 4, label: "各系經費" },
        { value: 5, label: "其他" },
      ],
      registerCarArray: [],
      registerCarOptions: [
        { value: 0, label: "公務車" },
        { value: 1, label: "租賃車" },
        { value: 2, label: "遊覽車" },
        { value: 3, label: "無" },

      ],
      selected2: null,
      diverOptions1: [
        { value: "林春庭/0963-669-698", text: "林春庭" },
        { value: "張俊傑/0932-538-012", text: "張俊傑" },
        { value: "陳盈帆/0920-188-115", text: "陳盈帆" },
      ],
      diverOptions2: [
        { value: "0963-669-698", text: "0963-669-698" },
        { value: "0932-538-012", text: "0932-538-012" },
        { value: "0920-188-115", text: "0920-188-115" },
      ],
      diverOptions3: [
        { value: "3127-SF(7人)", text: "3127-SF(7人)" },
        { value: "6680-C9(4人)", text: "6680-C9(4人)" },
        { value: "BRL-0238(8人)", text: "BRL-0238(8人)" },
      ],
      options2: [
        { value: 4, text: "不分群" },
        { value: 5, text: "電機與電子群" },
        { value: 6, text: "機械群" },
        { value: 7, text: "動力機械群" },
        { value: 8, text: "化工群" },
        { value: 9, text: "商管群" },
        { value: 10, text: "土木與建築群" },
        { value: 11, text: "設計群" },
        { value: 12, text: "農業群" },
      ],
      options3: [
        { value: 5, text: "電機與電子群" },
        { value: 6, text: "機械群" },
        { value: 7, text: "動力機械群" },
        { value: 8, text: "化工群" },
        { value: 9, text: "商管群" },
        { value: 10, text: "土木與建築群" },
        { value: 11, text: "設計群" },
        { value: 12, text: "農業群" },
        { value: 13, text: "產學班" },
      ],
      options4: [
        { key: "1", value: "A4", text: "公務車4人座" },
        { key: "2", value: "B6", text: "公務車6人座" },
        { key: "3", value: "C8", text: "公務車8人座" },
        { key: "4", value: "D3", text: "租賃車3人座" },
        { key: "5", value: "E8", text: "租賃車8人座" },
        { key: "6", value: "F18", text: "遊覽車18人座" },
        { key: "7", value: "G40", text: "遊覽車40人座" },
        { key: "8", value: "H1", text: "自行前往(大眾運輸)" },
        { key: "9", value: "I1", text: "自行開車(車牌)" },
      ],
      options5: [
        { value: 1, text: "復通樓門口" },
        { value: 2, text: "圖資館門口" },
        { value: 3, text: "工程館(靠勤益大道)" },
        { value: 4, text: "青永館門口" },
        { value: 5, text: "國秀樓門口" },
        { value: 6, text: "管理館(後門)" },
        { value: 12, text: "本校青永館６樓靜軒暨無紙化會議室)" },
      ],
      options6: [
        { value: "999", text: "不指定", disabled: false },
        { value: "11", text: "電機工程系", disabled: false },
        { value: "14", text: "電子工程系", disabled: false },
        { value: "40", text: "資訊工程系", disabled: false },
        {
          value: "47",
          text: "人工智慧應用工程系",
          disabled: false,
        },
        { value: "22", text: "機械工程系", disabled: false },
        {
          value: "25",
          text: "冷凍空調與能源系",
          disabled: false,
        },
        {
          value: "19",
          text: "化工與材料工程系",
          disabled: false,
        },
        {
          value: "46",
          text: "智慧自動化工程系",
          disabled: false,
        },
        { value: "27", text: "企業管理系", disabled: false },
        {
          value: "33",
          text: "健康產業科技研發與管理系",
          disabled: false,
        },
        {
          value: "16",
          text: "工業工程與管理系",
          disabled: false,
        },
        { value: "26", text: "行銷與流通管理系", disabled: false },
        { value: "38", text: "資訊管理系", disabled: false },
        {
          value: "32",
          text: "文化創意事業系",
          disabled: false,
        },
        { value: "35", text: "應用英語系", disabled: false },
        { value: "24", text: "景觀系", disabled: false },
      ],
      linkText: null,
      total: 0,
      isIE: false,
      getTeacherData: null,
      inputData: {
        cid: null,
        schoolID: null,
        schoolName: null,
        typeName: null,
        sid: null,
        activeName: null,
        updateUser: null,
        sActiveTime: null,
        eActiveTime: null,
        sn: null,
        pid: null,
        studentGroup: 0,
        tidsArray: [],
        schoolGatherTime: null,
        goBySelfGatherTime: null,
        goBySelfGatherPlace: null,
        campusMap: false,
        file: [],
        Info1: [],
        classNumber: 0,
        classNumber2: 0,
        studentNumber: 0,
        eid: null,
        activeNumber: 0,
        sdateTime: null,
        edateTime: null,
        class: false,
        classNameArray: [],
        depIDStringArray: [],
        rowId: "",
        remark: "",
        driverName: "",
        driverPhone: "",
        licensePlate: "",
        registerCar:null,
        budgetArray:[],
        registerCarArray:[],
      },
      inputData5: null,
      localInputData5: null,
      inputData6: null,
      localInputData6: null,
      inputData7: null,
      localInputData7: null,
      inputData8: null,
      localInputData8: null,
      inputData9: null,
      placeInput: null,
      localInputData2: null,
      currentPage: 1,
      cid: "",
      pageSize: 10,
      activeName: "",
      disabledRows: [],
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    combinedText() {
      if (this.PublicizeEnable) {
        const o2 = this.options2.find(
          (x) => x.value == this.inputData.studentGroup
        );
        if (o2 != null) {
          this.inputData.activeName =
            this.inputData.schoolName +
            this.inputData.typeName +
            this.activeName +
            o2.text;
        }
      } else if (this.SeminarEnable) {
        const o3 = this.options3.find(
          (x) => x.value == this.inputData.studentGroup
        );
        if (o3 != null) {
          this.inputData.activeName =
            this.inputData.schoolName +
            this.inputData.typeName +
            this.activeName +
            o3.text;
        }
      } else {
        this.inputData.activeName =
          this.inputData.schoolName + this.inputData.typeName + this.activeName;
      }

      return this.inputData.activeName;
    },
  },

  components: {
    flatPickr,
  },
  methods: {
    clearPlacePID() {
      this.inputData.pid = null; // 清空数据
    },
    driverChang(mode2) {
      if (mode2 == false) {
        this.mode2 = false;
        this.DriverEnable = false;
        this.inputData.driverName = "";
        this.inputData.driverPhone = "";
        this.inputData.licensePlate = "";
      } else {
        this.mode2 = true;
        this.DriverEnable = true;
      }
    },
    handleCheckboxChange(value, index) {
      this.handleCheckboxValues(value, index);
    },
    handleCheckboxValues(values, index) {
      const is999Selected = values.includes("999");
      this.options6.forEach((option, i) => {
        this.$set(this.options6, i, {
          ...option,
          disabled:
            (is999Selected && i !== index) ||
            (!is999Selected && i === index && option.value !== "999"),
        });
      });
    },
    getAllEnrollContact() {
      let vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetAllEnrollContact/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData8 = response.data;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
        });
    },

    CloseEnable() {
      this.PublicizeEnable = false;
      this.SeminarEnable = false;
      this.ForumEnable = false;
      this.ClassEnable = false;
      this.StudentEnable = false;
    },

    updateActiveClass(sn) {
      if (sn == 3) {
        this.CloseEnable();
        this.PublicizeEnable = true;
        this.StudentEnable = true;
      } else if (sn == 8) {
        this.CloseEnable();
        this.SeminarEnable = true;
        this.StudentEnable = true;
      } else if (sn == 7) {
        this.CloseEnable();
        this.ForumEnable = true;
      } else if (sn == 14 || sn == 15 || sn == 16) {
        this.CloseEnable();
        this.ClassEnable = true;
      } else if (
        sn == 2 ||
        sn == 3 ||
        sn == 4 ||
        sn == 5 ||
        sn == 8 ||
        sn == 11 ||
        sn == 19
      ) {
        this.CloseEnable();
        this.StudentEnable = true;
      } else this.CloseEnable();
      if (this.inputData7 != null) {
        const i7 = this.inputData7.find((x) => x.sn === sn);

        if (i7) {
          this.inputData.typeName = i7.typeName;
        }
        this.combinedText;
      }

      // const selectedTypeName = this.inputData7.find(
      //   (school) => school.sn === this.inputData.sn
      // );

      // if (selectedTypeName) {
      //   this.localInputData7 = selectedTypeName;
      //   this.inputData.typeName = selectedTypeName.typeName;
      // }
    },
    getAllTypeName() {
      let vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetAllTypeName/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData7 = response.data;

            //console.log("this.inputData7=", this.inputData7);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    getAllSchoolContact() {
      let vm = this;
      this.$http
        .get("./WebApi/HighSchoolEnrolling/GetAllSchoolContact/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData5 = response.data;
            console.log("this.inputData5=", this.inputData5);
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
        });
    },
    updateSchoolContact() {
      if (this.inputData5 != null) {
        const selectedSchoolContacts = this.inputData5.filter(
          (school) => school.schoolID === this.inputData.schoolID
        );

        if (selectedSchoolContacts.length > 0) {
          this.localInputData5 = [...selectedSchoolContacts];
          console.log("this.localInputData5=", this.localInputData5);
          // console.log('selectedSchoolContacts=', selectedSchoolContacts);
        }
        // 觸發更新學校名稱的下拉選單
        this.updateSchool2();
      }
    },
    updateSchoolContact2() {
      if (this.inputData5 != null) {
        const selectedSchoolContact = this.inputData5.find(
          (school) => school.sid === this.inputData.sid
        );

        if (selectedSchoolContact) {
          this.localInputData6 = selectedSchoolContact;
          //console.log('this.localInputData6=', this.localInputData6);
        }
        // 觸發更新學校名稱的下拉選單
        this.updateSchool2();
      }
    },
    updateEnrollContact() {
      // 在這裡獲取選中的小組長
      const selectedEnrollContact = this.inputData8.find(
        (EnrollContact) => EnrollContact.eid === this.inputData.eid
      );

      if (selectedEnrollContact) {
        this.inputData8.name = selectedEnrollContact.name;
        this.inputData8.cellPhone = selectedEnrollContact.cellPhone;
      }
    },
    updateCity() {
      // 在這裡獲取選中的學校對象
      const selectedSchool = this.localInputData3.find(
        (school) => school.cid === this.inputData.cid
      );

      // 更新inputData.city
      if (selectedSchool) {
        this.inputData.city = selectedSchool.city;
      }
      // 觸發更新學校名稱的下拉選單
      this.updateSchool2();
      // 更新高中職窗口
      // this.updateSchoolContact();
    },
    updateSchool2() {
      // 在這裡獲取選中的學校對象
      const selectedSchools = this.orglocalInputData4.filter(
        (school) => school.cid === this.inputData.cid
      );

      this.localInputData2 = [...selectedSchools];

      //this.inputData.schoolID = ''; // 清空已選擇的學校名稱
    },

    updateSchool() {
      // 在這裡獲取選中的學校對象
      const selectedSchool = this.localInputData2.find(
        (school) => school.schoolID === this.inputData.schoolID
      );

      // 更新inputData.schoolName
      if (selectedSchool) {
        this.inputData.schoolName = selectedSchool.schoolName;
      }
      // 更新高中職窗口
      this.updateSchoolContact();
    },

    checkInput() {
      this.inputFlag = false;
      // if (tools.empty(this.inputData.sn)) {
      //   alert("請選擇活動類型");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (!this.ForumEnable && tools.empty(this.inputData.cid)) {
      //   alert("請選擇地區");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (!this.ForumEnable && tools.empty(this.inputData.schoolID)) {
      //   alert("請選擇學校名稱");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (!this.ForumEnable && tools.empty(this.inputData.sid)) {
      //   alert("請選擇高中職窗口");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (tools.empty(this.inputData.activeName)) {
      //   alert("請輸入活動名稱");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (tools.empty(this.inputData.sActiveTime)) {
      //   alert("請選擇開始活動時間");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (tools.empty(this.inputData.eActiveTime)) {
      //   alert("請選擇結束活動時間");
      //   this.inputFlag = true;
      //   return;
      // }

      // if ( tools.empty(this.inputData.tidsArray)) {
      //   alert("請選擇交通方式");
      //   this.inputFlag = true;
      //   return;
      // }
      // // if (tools.empty(this.inputData.schoolGatherTime)) {
      // //   alert("請選擇集合時間(統一出發)");
      // //   this.inputFlag = true;
      // //   return;
      // // }
      // // if (tools.empty(this.inputData.pid)) {
      // //   alert("請選擇集合地點(統一出發)");
      // //   this.inputFlag = true;
      // //   return;
      // // }
      // // if (tools.empty(this.inputData.goBySelfGatherTime)) {
      // //   alert("請選擇自行前往時間");
      // //   this.inputFlag = true;
      // //   return;
      // // }
      // // if (tools.empty(this.inputData.goBySelfGatherPlace)) {
      // //   alert("請輸入自行前往地點");
      // //   this.inputFlag = true;
      // //   return;
      // // }
      // if (this.inputData.campusMap == true && !tools.FileisEmpty(this.inputData.file)) {
      //   alert("請上傳該校校園地圖檔案");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (this.ClassEnable && tools.empty(this.inputData.classNumber)) {
      //   alert("請輸入班級數");
      //   this.inputFlag = true;
      //   return;
      // }
      if (
        (this.ClassEnable && tools.empty(this.inputData.studentNumber)) ||
        (this.StudentEnable && tools.empty(this.inputData.studentNumber))
      ) {
        alert("請輸入學生人數(DM數)");
        this.inputFlag = true;
        return;
      }
      // if (tools.empty(this.inputData.eid)) {
      //   alert("請選擇本活動小組長/手機");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (tools.empty(this.inputData.activeNumber)) {
      //   alert("請輸入本活動宣導人數");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (
      //   this.ClassEnable &&
      //   this.inputData.class == true &&
      //   this.inputData.classNumber2 > 0
      // ) {
      //   // 檢查每個班級名稱是否填入
      //   for (let index = 0; index < this.inputData.classNumber2; index++) {
      //     if (!this.inputData.classNameArray[index]) {
      //       alert("請輸入班級名稱");
      //       this.inputFlag = true;
      //       return;
      //     }
      //     if (
      //       !this.inputData.depIDStringArray[index] ||
      //       this.inputData.depIDStringArray[index].length === 0
      //     ) {
      //       alert("請選擇系所名稱");
      //       this.inputFlag = true;
      //       return;
      //     }
      //   }
      // }
      if (tools.empty(this.budgetArray)) {
        alert("請選擇經費來源");
        this.inputFlag = true;
        return;
      }
      if (tools.empty(this.registerCarArray)) {
        alert("請選擇登記交通車");
        this.inputFlag = true;
        return;
      }
      // if (tools.empty(this.inputData.sdateTime)) {
      //   alert("請選擇報名開始時間");
      //   this.inputFlag = true;
      //   return;
      // }
      // if (tools.empty(this.inputData.edateTime)) {
      //   alert("請選擇報名結束時間");
      //   this.inputFlag = true;
      //   return;
      // }
    },
    classChang(mode) {
      if (mode == false) {
        this.classMode = false;
        this.classMode2 = false;
        this.inputData.class = false;
      } else if (mode == true) {
        this.classMode = true;
        this.inputData.class = true;
      } else if (mode == 2) {
        this.classMode2 = true;
        this.inputData.class = true;
        this.inputData.classNumber2 = parseInt(this.inputData.classNumber2, 10); // 轉換為整數
        this.inputData.classNameArray = new Array(
          this.inputData.classNumber2
        ).fill([]);
        this.inputData.depIDStringArray = new Array(
          this.inputData.classNumber2
        ).fill([]);
      }
    },
    campusMapChang(mode) {
      if (mode == false) {
        this.mode = false;
        this.inputData.campusMap = false;
      } else {
        this.mode = true;
        this.inputData.campusMap = true;
      }
    },
    generateRandomString() {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let randomString = "";

      for (let i = 0; i < 16; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomString += characters.charAt(randomIndex);
      }

      return randomString;
    },

    fileChange(index) {
      this.formData = new FormData();

      if (index == 0) {
        this.formData.append(this.generateRandomString(), this.inputData.file);
      }
      var vm = this;

      this.$http
        .post("./WebApi/Common/UploadV3", vm.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            console.log(
              "Upload progress: " +
                Math.round((progressEvent.loaded / progressEvent.total) * 100) +
                "%"
            );
          },
        })
        .then(function (response) {
          vm.inputData.Info1 = response.data;

          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
          console.log(error.response);
        });
    },
    getALLActiveList() {
      let vm = this;

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetALLActiveList/".concat(
            "0" + "/" + "0"
          )
        )
        .then((response) => {
          if (!tools.isNull(response) && response.data.length > 0) {
            vm.inputData = response.data;
            console.log("vm.inputData", vm.inputData);
            vm.total = vm.inputData.length;

            var date1 = new Date(vm.inputData[0].sdateTime);
            var date2 = new Date(vm.inputData[0].edateTime);

            // 取得現在的時間
            var now = new Date();

            // 進行比較
            if (now >= date1 && now <= date2) {
              vm.TimeOpenShow = true;
            } else {
              vm.TimeOpenShow = false;
            }
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    EditActive2() {
      this.checkInput();
      this.inputData.updateUser = this.user.id;
      this.inputData.budgetArray = this.budgetArray;
      this.inputData.registerCarArray = this.registerCarArray;
      if (!this.ClassEnable && !this.StudentEnable) {
        this.inputData.classNumber = 0;

      }

      this.inputData.activeNumber = parseInt(this.inputData.activeNumber, 10); // 轉換為整數
      this.inputData.classNumber = parseInt(this.inputData.classNumber, 10); // 轉換為整數
      this.inputData.studentNumber = parseInt(this.inputData.studentNumber, 10); // 轉換為整數

      console.log("this.inputData=", this.inputData);

      let vm = this;
      if (this.inputFlag != true) {
        this.$http
          .put("./WebApi/HighSchoolEnrolling/EditActive2/", this.inputData)
          .then((response) => {
            if (0 < response.data) {
              tools.showAlert(vm, "success", "修改活動成功");
              vm.getALLActiveList();
              this.close();
            } else {
              tools.showAlert(vm, "danger", "對不起,增加活動失敗");
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      }
    },
    onContext(ctx) {
      // this.inputData.sdate = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    close() {
      this.$emit("hideModal");
    },
    getAllSchoolGatherPlace() {
      var IsDelete = false;
      let vm = this;
      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetAllSchoolGatherPlace/".concat(
            IsDelete
          )
        )
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.placeInput = response.data.map((item) => {
              return {
                value: item.pid,
                text: item.schoolGatherPlace,
              };
              console.log("vm.placeInput", vm.placeInput);
            });
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    convertDateFormat(inputDate) {
      // 將中文星期轉換為英文
      const chineseToEnglishDays = {
        星期日: "Sunday",
        星期一: "Monday",
        星期二: "Tuesday",
        星期三: "Wednesday",
        星期四: "Thursday",
        星期五: "Friday",
        星期六: "Saturday",
      };

      // 分割輸入的日期和時間
      const parts = inputDate.split(" ");

      // 提取日期和時間部分
      const dateString = parts[0];
      const timeString = parts[2] + " " + parts[3]; // '12:00 AM'

      // 將中文星期轉換為英文
      const englishDay = chineseToEnglishDays[parts[1]];

      // 格式化輸出日期
      const formattedDate = dateString + " " + englishDay + " " + timeString;

      return formattedDate;
    },
    getActiveDetailVa() {
      let vm = this;

      this.$http
        .get(
          "./WebApi/HighSchoolEnrolling/GetActiveDetailVa/".concat(
            vm.$props.aid + "/" + vm.ClassEnable
          )
        )
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData9 = response.data;

            console.log("vm.inputData9", vm.inputData9);

            // 顯示模態框
            vm.$nextTick(() => {
              const modalInstance = vm.inputData9;
              if (modalInstance) {
                vm.classMode2 = true;
                vm.inputData.aid = vm.inputData9[0].aid;
                vm.inputData.accompany = vm.inputData9[0].accompany;
                vm.inputData.studentGroup = vm.inputData9[0].studentGroup;
                vm.inputData.cid = vm.inputData9[0].cid;
                vm.updateCity();
                vm.inputData.schoolID = vm.inputData9[0].schoolID;
                vm.updateSchool();
                vm.inputData.sid = vm.inputData9[0].sid;
                vm.updateSchoolContact2();
                vm.inputData.activeName = vm.inputData9[0].activeName;
                // vm.inputData.sActiveTime = vm.convertDateFormat(vm.inputData9[0].sActiveTime);
                // vm.inputData.eActiveTime = vm.convertDateFormat(vm.inputData9[0].eActiveTime);
                vm.inputData.sActiveTime = vm.inputData9[0].sActiveTime;
                vm.inputData.eActiveTime = vm.inputData9[0].eActiveTime;
                // vm.inputData.sActiveTime = "2024-01-02 Tuesday 11:00 PM";
                // vm.inputData.eActiveTime = vm.inputData9[0].eActiveTime;
                vm.inputData.schoolGatherTime =
                  vm.inputData9[0].schoolGatherTime;
                vm.inputData.pid = vm.inputData9[0].pid;
                vm.inputData.goBySelfGatherTime =
                  vm.inputData9[0].goBySelfGatherTime;
                vm.inputData.goBySelfGatherPlace =
                  vm.inputData9[0].goBySelfGatherPlace;
                vm.inputData.campusMap = vm.inputData9[0].campusMap;
                vm.campusMapChang(vm.inputData.campusMap);
                vm.inputData.eid = vm.inputData9[0].eid;
                vm.inputData.activeNumber = vm.inputData9[0].activeNumber;
                vm.inputData.class = vm.inputData9[0].class;
                vm.inputData.classNumber = vm.inputData9[0].classNumber;
                vm.inputData.classNumber2 = vm.inputData9[0].classNumber2;
                vm.inputData.studentNumber = vm.inputData9[0].studentNumber;
                vm.inputData.classNameArray = vm.inputData9[0].classNameArray;
                vm.inputData.depIDStringArray =
                  vm.inputData9[0].depIDStringArray;
                  var dateObject1 = new Date(vm.inputData9[0].sdateTime);
var isoString1 = dateObject1.toISOString();
vm.inputData9[0].sdateTime = isoString1.substring(0, isoString1.indexOf(".000Z"));
vm.inputData.sdateTime = vm.inputData9[0].sdateTime.replace("T", " ");

var dateObject2 = new Date(vm.inputData9[0].edateTime);
var isoString2 = dateObject2.toISOString();
vm.inputData9[0].edateTime = isoString2.substring(0, isoString2.indexOf(".000Z"));
vm.inputData.edateTime = vm.inputData9[0].edateTime.replace("T", " ");

          //      vm.inputData.sdateTime = vm.inputData9[0].sdateTime;
           //     vm.inputData.edateTime = vm.inputData9[0].edateTime;
                vm.inputData.driverName = vm.inputData9[0].driverName;
                vm.inputData.driverPhone = vm.inputData9[0].driverPhone;
                vm.inputData.licensePlate = vm.inputData9[0].licensePlate;
                vm.inputData.remark = vm.inputData9[0].remark;
                vm.inputData.registerCar = vm.inputData9[0].registerCar;
              }
            });
            // 使用 Array.from
            vm.inputData9[0].tidsArray = Array.from(
              response.data[0].tids.split(",")
            );
            vm.inputData.tidsArray = vm.inputData9[0].tidsArray;
            vm.inputData9[0].budgetArray = Array.from(
              response.data[0].budget.split(",")
            );
            vm.inputData9[0].registerCarArray = Array.from(
              response.data[0].registerCar.split(",")
            );
            vm.inputData9[0].activeClass = "";
            if (vm.inputData9[0].studentGroup != 0) {
              const matchedOption2 = vm.options2.find(
                (option) => option.value === vm.inputData9[0].studentGroup
              );
              if (matchedOption2) {
                vm.inputData9[0].activeClass = matchedOption2.text;
              }
            }

            vm.budgetArray = vm.inputData9[0].budgetArray;
            vm.registerCarArray = vm.inputData9[0].registerCarArray;
            // 或者使用 Array.prototype.slice.call
            // vm.inputData[0].tidsArray = Array.prototype.slice.call(response.data[0].tids.split(","));
            vm.inputData9[0].tidsArray.forEach((element) => {
              const matchedOptionIndex = vm.options4.findIndex(
                (option) => option.value === element
              );

              // if (matchedOptionIndex !== -1) {
              //   const dynamicPropertyName = `total_${element}`;

              //   // 使用動態屬性存取方式，獲取實際值
              //   const dynamicPropertyValue =
              //     vm.inputData9[0][dynamicPropertyName];

              //   vm.options4[
              //     matchedOptionIndex
              //   ].text = `${vm.options4[matchedOptionIndex].text} 已報名 ${dynamicPropertyValue} 位`;
              // } else {
              //   console.log(`未知選項: ${element}`);
              // }
            });

            if (
              response.data[0].campusMap == true &&
              response.data[0].attachInfoString != null
            ) {
              vm.mode = true;
              const jsonArr = JSON.parse(response.data[0].attachInfoString);
              if (!tools.empty(jsonArr)) {
                vm.inputData.file.name = jsonArr.FileNm;
                vm.inputData.file.RowId = jsonArr.RowId;
                vm.inputData.rowId = jsonArr.RowId;
              }
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    init() {
      let vm = this;
      vm.updateActiveClass(vm.$props.sn);
      vm.getActiveDetailVa();
      vm.inputData.sn = vm.$props.sn;
    },
  },
  created() {
    console.log("======created EditActive2View =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    console.log("this.$props.inputData3", this.$props.inputData3);
    console.log(
      "this.$props.orglocalInputData3",
      this.$props.orglocalInputData3
    );
    this.getAllSchoolContact();

    this.localInputData3 = JSON.parse(JSON.stringify(this.$props.inputData3));
    this.orglocalInputData4 = JSON.parse(
      JSON.stringify(this.$props.orglocalInputData3)
    );
    this.init();
  },
  mounted() {
    console.log("======mounted EditActive2View =====");
    this.getAllTypeName();
    this.getAllEnrollContact();
    this.getAllSchoolGatherPlace();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
